var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotspotHubs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 17.7087C1.5 15.5022 1.5 14.399 1.80513 13.5105C2.36882 11.8692 3.65826 10.5798 5.29959 10.0161C6.18806 9.71094 7.29131 9.71094 9.49779 9.71094H10.6446C12.4135 9.71094 13.298 9.71094 14.0321 9.86468C16.8469 10.4541 19.0461 12.6533 19.6355 15.4681C19.7893 16.2022 19.7893 17.0867 19.7893 18.8556C19.7893 20.6245 19.7893 21.5089 19.6355 22.2431C19.0461 25.0578 16.8469 27.257 14.0321 27.8465C13.298 28.0002 12.4135 28.0002 10.6446 28.0002C8.87575 28.0002 7.9913 28.0002 7.25715 27.8465C4.44239 27.257 2.24318 25.0578 1.65374 22.2431C1.5 21.5089 1.5 20.6245 1.5 18.8556V17.7087Z",
    fill: "#C4C4C4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0257,
    cy: 16.7503,
    r: 2.58621,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.2153 5.86485C16.7489 5.70846 16.252 5.95924 16.1048 6.42695C15.962 6.89386 16.224 7.39993 16.6897 7.5555C17.9868 7.99006 19.2366 8.93244 20.2106 10.2104C21.1841 11.4875 21.7621 12.9432 21.8373 14.309C21.8639 14.7994 22.2824 15.1862 22.7712 15.1716C22.953 15.1649 23.1248 15.1038 23.2669 14.9954C23.4961 14.8207 23.6223 14.5423 23.6068 14.2503C23.512 12.5259 22.8028 10.7126 21.6081 9.14519C20.4135 7.57781 18.853 6.41336 17.2153 5.86485Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M17.8594 1.72092C17.3952 1.56413 16.8954 1.8145 16.7496 2.28242C16.6068 2.74932 16.8688 3.25539 17.3338 3.41158C19.5275 4.14635 21.6374 5.73352 23.2733 7.87977C24.9098 10.0268 25.8809 12.482 26.008 14.792C26.0359 15.2826 26.4538 15.6685 26.9427 15.654C27.1245 15.6473 27.2955 15.5867 27.4376 15.4784C27.6668 15.3037 27.7938 15.0247 27.7775 14.7333C27.6317 12.064 26.5285 9.2519 24.6708 6.81458C22.8143 4.37889 20.3945 2.56904 17.8594 1.72092Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotspotHubs);
export default __webpack_public_path__ + "static/media/hotspot-hubs.d4b4f05ec6ebea2427e1650b140715dc.svg";
export { ForwardRef as ReactComponent };